import { Button, Group, Stack, Text } from '@repletoryreach/sdk-ui';
import { useT } from '../../../../i18n/I18nProvider';
import { formatInteger } from '../../../../lib/format';
import { LanguageSwitch, LinesCell, MetaCodesCell, QualityBadge } from './cells';
import type { LanguageRowsProps } from './LanguagesTable';

const MUTED = 'var(--rr-color-text-muted)';

/**
 * The same rows for a phone: the own name and the switch on one line, then its quality, Meta codes, chatbots and
 * built-in lines, then Built-in lines and Edit. Nothing scrolls sideways.
 */
export function LanguagesList({ languages, busy, onToggle, onEdit, onLines }: LanguageRowsProps) {
  const t = useT();
  return (
    <Stack gap="xs">
      {languages.map((l) => (
        <div key={l.code} className="rr-list-row rr-languages-row">
          <Stack gap="xs">
            <Group justify="space-between" align="flex-start" gap="sm" wrap="nowrap">
              <Stack gap={2} style={{ minWidth: 0 }}>
                <Text role="subtitle" fw={600}>{l.native_name}</Text>
                <Text role="caption" c={MUTED}>{l.name} · <code>{l.code}</code></Text>
              </Stack>
              <div style={{ flexShrink: 0 }}>
                <LanguageSwitch language={l} busy={busy === l.code} onToggle={onToggle} />
              </div>
            </Group>
            <dl className="rr-languages-facts">
              <div>
                <dt><Text role="overline" c={MUTED}>{t('billing.languages.columns.quality')}</Text></dt>
                <dd><QualityBadge quality={l.quality} /></dd>
              </div>
              <div>
                <dt><Text role="overline" c={MUTED}>{t('billing.languages.columns.meta')}</Text></dt>
                <dd><MetaCodesCell language={l} /></dd>
              </div>
              <div>
                <dt><Text role="overline" c={MUTED}>{t('billing.languages.columns.bots')}</Text></dt>
                <dd><Text role="bodySmall">{formatInteger(l.bots_offering)}</Text></dd>
              </div>
              <div>
                <dt><Text role="overline" c={MUTED}>{t('billing.languages.columns.lines')}</Text></dt>
                <dd><LinesCell language={l} /></dd>
              </div>
            </dl>
            <Group gap="xs" justify="flex-end" wrap="nowrap">
              <Button size="xs" variant="outline" onClick={() => onLines(l)} aria-label={t('billing.languages.lines.actionFor', { name: l.name })}>
                {t('billing.languages.lines.action')}
              </Button>
              <Button size="xs" variant="subtle" onClick={() => onEdit(l)} aria-label={t('billing.languages.edit.actionFor', { name: l.name })}>
                {t('action.edit')}
              </Button>
            </Group>
          </Stack>
        </div>
      ))}
    </Stack>
  );
}
